if (!customElements.get('product-form')) {
  customElements.define(
    'product-form',
    class ProductForm extends HTMLElement {
      constructor() {
        super();

        this.form = this.querySelector('form');
        this.form.querySelector('[name=id]').disabled = false;
        this.form.addEventListener('submit', this.onSubmitHandler.bind(this));
        this.cart = document.querySelector('cart-drawer');
        this.submitButton = this.querySelector('[type="submit"]');

        if (document.querySelector('cart-drawer')) this.submitButton.setAttribute('aria-haspopup', 'dialog');

        this.hideErrors = this.dataset.hideErrors === 'true';
      }

      onSubmitHandler(evt) {
        evt.preventDefault();
        
        if (this.submitButton.getAttribute('aria-disabled') === 'true') return;

        this.handleErrorMessage();

        this.submitButton.setAttribute('aria-disabled', true);
        this.submitButton.classList.add('loading');
        this.querySelector('.loading__spinner').classList.remove('hidden');

        const config = fetchConfig('javascript');
        config.headers['X-Requested-With'] = 'XMLHttpRequest';

        let formData = new FormData(this.form);
        
        // Collect all items to add: main product + addon products
        let items = [];
        
        // Add main product
        let mainProductData = {};
        let properties = {};
        for (let [key, value] of formData.entries()) {
          mainProductData[key] = value;
          // Collect properties fields (e.g., properties[_subscription_id])
          if (key.startsWith('properties[')) {
            const propName = key.match(/properties\[(.*?)\]/)[1];
            properties[propName] = value;
          }
        }
        
        let mainItem = {
          id: mainProductData.id,
          quantity: parseInt(mainProductData.quantity) || 1
        };
        
        // Add selling_plan if present
        if (mainProductData.selling_plan) {
          mainItem.selling_plan = mainProductData.selling_plan;
        }
        
        // Add properties if any
        if (Object.keys(properties).length > 0) {
          mainItem.properties = properties;
        }
        
        items.push(mainItem);
        
        // Check for addon products
        const checkedAddons = document.querySelectorAll(".addon_product input[type='checkbox']:checked");
        if (checkedAddons.length > 0) {
          console.log("Found checked addons:", checkedAddons.length);
          checkedAddons.forEach(checkbox => {
            const formParent = checkbox.closest('.addon_product');
            const form = formParent.querySelector('form');
            const variantID = form.querySelector('[name="id"]').value;
            items.push({
              id: variantID,
              quantity: 1
            });
          });
        }
        
        let requestData = { items: items };
        
        console.log("Adding items to cart with selling_plan:", items);
        
        // Build sections query params
        let sectionsUrl = '';
        if (this.cart) {
          let sectionsToRender = this.cart.getSectionsToRender().map((section) => section.id); 
          
          // Also include cart notification sections if cart notification exists
          const cartNotification = document.querySelector('cart-notification');
          if (cartNotification) {
            const notificationSections = cartNotification.getSectionsToRender().map((section) => section.id);
            // sectionsToRender = [...sectionsToRender, ...notificationSections];
          }
          
          sectionsUrl = `?sections=${sectionsToRender.join(',')}&sections_url=${window.location.pathname}`;
          this.cart.setActiveElement(document.activeElement);
        }
        
        config.body = JSON.stringify(requestData);

        fetch(`${routes.cart_add_url}${sectionsUrl}`, config)
          .then((response) => response.json())
          .then((response) => {
            if (response.status) {
              publish(PUB_SUB_EVENTS.cartError, {
                source: 'product-form',
                productVariantId: items[0].id,
                errors: response.errors || response.description,
                message: response.message,
              });
              this.handleErrorMessage(response.description);

              const soldOutMessage = this.submitButton.querySelector('.sold-out-message');
              if (!soldOutMessage) return;
              this.submitButton.setAttribute('aria-disabled', true);
              this.submitButton.querySelector('span').classList.add('hidden');
              soldOutMessage.classList.remove('hidden');
              this.error = true;
              return;
            } else if (!this.cart) {
              window.location = window.routes.cart_url;
              return;
            }

            if (!this.error) {
              publish(PUB_SUB_EVENTS.cartUpdate, {
                source: 'product-form',
                productVariantId: items[0].id,
                cartData: response,
              });
              
              // Show success message
              if (typeof window.showCartSuccessMessage === 'function') {
                window.showCartSuccessMessage();
              }
            }
            console.log("response:", response);
            this.error = false;
            const quickAddModal = this.closest('quick-add-modal');
            if (quickAddModal) {
              document.body.addEventListener(
                'modalClosed',
                () => {
                  setTimeout(() => {
                    this.cart.renderContents(response);
                  });
                },
                { once: true }
              );
              quickAddModal.hide(true);
            } else {
              
              // Check A/B test variant
              const abTestVariant = window.cartAbTestVariant;
              console.log("Cart A/B Test variant:", abTestVariant);
              
              if (abTestVariant === 'direct-drawer') {
                // Test variant: Skip popup, go directly to cart drawer
                console.log("A/B Test: Showing cart drawer directly");
                this.cart.renderContents(response);
              } else {
                // Control variant: Show cart notification popup (current behavior)
                const cartNotification = document.querySelector('cart-notification');
                if (cartNotification) {
                  console.log("A/B Test: Showing cart popup (control variant)");
                  // Set active element for focus management
                  cartNotification.setActiveElement(document.activeElement);
                  // Render the cart notification with the response data
                  cartNotification.renderContents(response);
                  this.cart.renderContents(response, true);
                } else {
                  // Fallback to cart drawer if notification doesn't exist
                  console.log("Fallback: Cart notification not found, showing cart drawer");
                  this.cart.renderContents(response);
                }
              }
            }
          })
          .catch((e) => {
            console.error(e);
          })
          .finally(() => {
            this.submitButton.classList.remove('loading');
            if (this.cart && this.cart.classList.contains('is-empty')) this.cart.classList.remove('is-empty');
            if (!this.error) this.submitButton.removeAttribute('aria-disabled');
            this.querySelector('.loading__spinner').classList.add('hidden');
        });
        
      }

      handleErrorMessage(errorMessage = false) {
        if (this.hideErrors) return;

        this.errorMessageWrapper =
          this.errorMessageWrapper || this.querySelector('.product-form__error-message-wrapper');
        if (!this.errorMessageWrapper) return;
        this.errorMessage = this.errorMessage || this.errorMessageWrapper.querySelector('.product-form__error-message');

        this.errorMessageWrapper.toggleAttribute('hidden', !errorMessage);

        if (errorMessage) {
          this.errorMessage.textContent = errorMessage;
        }
      }
    }
  );
}
if (!customElements.get('discount-code')) {
  class DiscountCodeBar extends HTMLElement {
    constructor() {
      super();
    }
    connectedCallback() {
      const discountField = this.querySelector('.discount-field__input');
      const copyButton = this.querySelector('.button-copy__discount');
      const primaryLabel = copyButton.dataset.primaryLabel;
      const secondaryLabel = copyButton.dataset.secondaryLabel;
      
      copyButton.addEventListener('click', () => {
        discountField.select();
        console.log(secondaryLabel)
        discountField.setSelectionRange(0, 99999);
        document.execCommand('copy');
        discountField.setSelectionRange(0, 0);
        copyButton.textContent = secondaryLabel;
        setTimeout(() => {
          copyButton.textContent = primaryLabel;
        }, 2000);
      });
    }
  }
  customElements.define('discount-code', DiscountCodeBar);
} 

function initializeStickyAddToCart() {
  const stickyAtc = document.getElementById('sticky-add-to-cart');
  const mainAtc = document.querySelector('.product-form__submit');

  if (!stickyAtc || !mainAtc) return;

  function toggleStickyAtc() {
    const mainAtcRect = mainAtc.getBoundingClientRect();
    const isMainAtcVisible = mainAtcRect.bottom >= 0;

    if (!isMainAtcVisible) {
      console.log("is visible")
      stickyAtc.classList.add('visible');
    } else {
      stickyAtc.classList.remove('visible');
    }
  }

  function handleStickyAtcClick(event) {
    event.preventDefault();
    mainAtc.click();
    window.scrollTo({
      top: mainAtc.offsetTop - 100,
      behavior: 'smooth'
    });
  }

  window.addEventListener('scroll', toggleStickyAtc);
  stickyAtc.querySelector('button').addEventListener('click', handleStickyAtcClick);
}

document.addEventListener('DOMContentLoaded', initializeStickyAddToCart);

document.addEventListener("DOMContentLoaded", () => {
  if (document.querySelector('[part="price price--subscription"] [part="subscription-price"] .money')) {
    let price = document.querySelector('[part="price price--subscription"] [part="subscription-price"] .money').innerText;
    updatePrice(price)
  }
})
// Function to update the price in the sticky add to cart section
function updatePrice(salePrice, regularPrice) {
  const salePriceElement = document.querySelector('.sticky-add-to-cart__price .price-item--sale');
  const regularPriceElement = document.querySelector('.sticky-add-to-cart__price .price-item--regular');

  if (document.querySelector('.sticky-add-to-cart__price .price-item--sale') != null) {
    salePriceElement.textContent = salePrice;
    regularPriceElement.textContent = salePrice;
  }
}

// Add event listeners to the radio buttons
document.querySelectorAll('input[name="mode"]').forEach((radio) => {
  radio.addEventListener('change', (event) => {
    const selectedOption = event.target.value;

    // Get the prices based on the selected option
    let salePrice, regularPrice;
    if (selectedOption === 'subscription') {
      if (document.querySelector('[part="price price--subscription"] [part="subscription-price"] .money') != null) {
        price = document.querySelector('[part="price price--subscription"] [part="subscription-price"] .money').textContent;
        updatePrice(price);
      }
    } else {
      price = document.querySelector('.j-price .j-compare-price .money').textContent;
      updatePrice(price);
    }

    
  });
});